import {
  differencesBetweenTwoDates,
  TimeUnits,
} from '../dateAndTime/dateAndTime';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { PanoramaTransactions } from './consts';
import {
  ListAvailabilityTimeSlotsRequest,
  ListAvailabilityTimeSlotsResponse,
} from '@wix/ambassador-bookings-availability-v2-time-slot/types';

export async function panoramaQueryAvailabilityInteractionStart({
  request,
  flowAPI,
  transaction,
}: {
  flowAPI: ControllerFlowAPI;
  request: ListAvailabilityTimeSlotsRequest;
  transaction: PanoramaTransactions;
}) {
  const from = request?.fromLocalDate;
  const to = request?.toLocalDate;
  flowAPI.panoramaClient.transaction(transaction).start({
    customParams: {
      rangeInDays:
        from && to ? differencesBetweenTwoDates(from, to, TimeUnits.day) : 0,
      numberOfLocations: request.locations?.length,
      numberOfStaffMembers: request.resourceIds?.length,
      serviceType: request.serviceId,
    },
  });
}
export async function panoramaQueryAvailabilityInteractionEnd({
  response,
  flowAPI,
  error,
  transaction,
}: {
  flowAPI: ControllerFlowAPI;
  response?: ListAvailabilityTimeSlotsResponse;
  error?: string;
  transaction: PanoramaTransactions;
  request: ListAvailabilityTimeSlotsRequest;
}) {
  flowAPI.panoramaClient.transaction(transaction).finish({
    customParams: {
      numberOfTimeSlots: response?.timeSlots?.length,
      error,
    },
  });
}